import { FlatAspect } from "@/models/HomePageSearchResponse";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Fragment } from "react";

export default function AspectSelect({
  aspectKey,
  aspectLabel,
  value,
  options,
  onValueChange,
  variant,
  fullWidth,
  size,
  minWidth,
}: {
  aspectKey: string;
  aspectLabel: string;
  value: string;
  options: FlatAspect[];
  onValueChange: (aspectId: string) => void;
  variant?: "standard" | "outlined" | "filled";
  fullWidth?: boolean;
  size?: "small" | "medium";
  minWidth?: number;
}) {
  return (
    <FormControl
      fullWidth={typeof fullWidth === "undefined" ? !minWidth : fullWidth}
      variant={variant || "outlined"}
      size={size || "medium"}
      sx={{
        minWidth: minWidth,
        "&&& .MuiInputBase-root fieldset": {
          borderColor: "grey.400",
        },
      }}
    >
      <InputLabel id={aspectKey + "-select-label"}>{aspectLabel}</InputLabel>
      <Select
        labelId={aspectKey + "-select-label"}
        id={aspectKey + "-select"}
        value={value}
        label={aspectLabel}
        onChange={(e) => onValueChange(e.target.value as string)}
      >
        {options.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {[...Array(option.level).keys()].map((i) => (
              <Fragment key={i}>&nbsp;&nbsp;&nbsp;&nbsp;</Fragment>
            ))}{" "}
            {option.label}
            {option.count && (
              <>
                &nbsp;<small>({option.count})</small>
              </>
            )}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
